export enum DoorLockPrepSpecialCode {
  'CVRODP' = 'Exit Device, CVR',
  'MOLCVRB' = 'Exit Device, Mortise',
  'MOLCVRT' = 'Exit Device, Mortise',
  'MOLP' = 'Lock, Mortise',
  'MOLRIMP' = 'Exit Device, Mortise',
  'RIMP' = 'Exit Device, Rim',
  'VRODP' = 'Exit Device, SVR',
}
